import React from "react";
import { BsLinkedin, BsGithub, BsStackOverflow } from "react-icons/bs";

const HeaderSocial = () => {
  return (
    <div className="header__social">
      <a href="https://www.linkedin.com/in/ijaz-bacha/" target="_blank">
        <BsLinkedin />
      </a>
      <a href="https://github.com/ijazbacha" target="_blank">
        <BsGithub />
      </a>
      <a href="https://stackoverflow.com/users/12519010/ijaz-bacha?tab=profile" target="_blank">
        <BsStackOverflow />
      </a>
    </div>
  );
};

export default HeaderSocial;
